export const STEPPER_TEXTS = {
  summary: 'Paso {step} de {total}',
};

export const SUBSCRIPTION_STEPS = [
  { title: 'Ahorro', description: 'Indica el monto y unidad' },
  { title: 'Régimen y fondo', description: 'Elige tu régimen y tu fondo' },
  { title: 'Tu empleador', description: 'Confirma los datos de tu empleador' },
  { title: 'Confirma', description: 'Revisa tu suscripción' },
];
